/**
 * Compile-time Feature Flags / Nav-Konfiguration.
 * Nach Änderung: Frontend neu bauen/deployen.
 */
export const FEATURE_FLAGS = {
    /**
     * Links zu /liga/1-bundesliga/playoffs:
     * Desktop-Nav (Top-Level + Untermenü 1. BL), Mobile-Nav (Top-Level), Home-Button.
     * Die Liga-Subnavigation steuert sich weiterhin über vorhandene playoff_v2_*.json.
     */
    showPlayoffsLinks: false,

    /**
     * Super-Cup-Match im Nav (Desktop + Mobile Untermenü).
     */
    superCupMatch: {
        matchId: 90058,
        leagueId: 4,
        label: 'Rexel Super Cup 2026',
    },

    /**
     * Saisonauswahl in der Liga-Subnavigation (year-Filter).
     * maxYear anheben, sobald die nächste Saison im Dropdown erscheinen soll.
     */
    seasonSelect: {
        minYear: 2022,
        maxYear: 2025,
    },
};

export function superCupMatchPath() {
    const { matchId, leagueId } = FEATURE_FLAGS.superCupMatch;
    return `/match/${matchId}/${leagueId}`;
}
